import React from "react";
import { JobDescriptionFormWidget } from "app/widgets/job-description-form";

export const JobDescriptionRequestPage = () => {
  return (
    <JobDescriptionFormWidget
      onSubmit={(fields) => console.log("submit", fields)}
      onStatusChange={(status) => console.log("status", status)}
    />
  );
};


